<template>
    <section class="ageTechDetailBox">
        <div class="inner row3_1 flex mobileFlexCol">
            <article class="wd100">
                <div class="top">
                    <p class="info-title">
                        {{ title }}
                    </p>
                    <div class="info-box flex" style="align-items: center;">
                        <div class="info-detail-txt">
                            <p class="regDate">{{ regDate }}</p>
                        </div>
                        <div class="divider"></div>
                        <div class="info-detail-txt">
                            <p class="userName">{{ name }}</p>
                        </div>
                        <div class="divider"></div>
                        <div class="info-detail-txt">
                            <p class="viewCount">{{ viewCnt }}</p>
                        </div>
                        <div class="divider"></div>
                        <div class="info-detail-txt">
                            <p class="category">카테고리1</p>
                        </div>
                    </div>
                </div>
                <div class="video-img-Box wd100 flex" style="padding: 1rem 1rem;">
                    <!-- 링크가 있을 때 -->
                    <iframe v-if="this.vimeoLink" width="943" height="524" :src="getEmbedLink(this.vimeoLink)" title="Vimeo video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    <iframe v-if="this.youtubeLink" width="943" height="524" :src="getEmbedLink(this.youtubeLink)" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    <!-- 첨부파일이 있을 때 -->
                    <p v-for="(file, index) in fileList" :key="index">
                        <video v-if="file" width="943" height="524" :src="getVideoUrl(file.SAVE_FILE_NAME)" controls>
                            Your browser does not support the video tag.
                        </video>
                    </p>
                    <!-- <img :src="img" alt=""> -->
                </div>
                <div class="textBox">
                    <span v-html="contentHtml"></span>
                </div>
                <div class="btnWrap">
                    <a @click="$router.go(-1)" class="subBtnContain flex flexAlignS">
                        목록
                    </a>
                </div>
            </article>
        </div>
    </section>
</template>
  
  <script>
  import axios from '@/axios/axios'
  import * as htmlUtil from '@/utils/htmlUtil'
  import { resolveApiUrl } from '@/data/url'
  //import * as FileUtil from '@/utils/FileUtil'
  
  export default {
      data() {
          return {
              idx: this.$route.params.idx,
              title: '',
              content: '',
              viewCnt: 0,
              regDate: '',
              fileList: null,
              name: '',
              vimeoLink: '',
              youtubeLink: '',
              img:require('../../assets/images/product/starbucks.png')
          }
      },
      computed: {
          contentHtml(){
              return htmlUtil.stringToTag(this.content)
          }
      },
      methods: {
        //   async getDetail() {
        //       return await this.$api('/ageTechService/'+ this.idx, 'get', null, {
        //       })
        //       .then((response) => {
        //           const ageTechService = response.data.ageTechService
        //           this.title = ageTechService.TITLE;
        //           this.content = ageTechService.CONTENT
        //           this.file = ageTechService.FILE[0]
        //           this.userName = ageTechService.USER_NAME
        //           this.viewCount = ageTechService.VIEW_COUNT
        //           this.regdate = ageTechService.REGDATE
        //       })
        //       .catch((error) => {
        //           this.$alert("알림", `컨텐츠를 불러오는데 실패했습니다. <br>`+ error.response.data.error);
        //       })
        //   },
        getDetail(){
            // console.log("idx:"+this.$route.params.idx)
            let param = {
                IDX : this.idx
            };

            axios.post('/api/video/getVideoInfo', param)
            .then(response => {
                if(response.status == 200){
                    let data = response.data.VIDEO;
                    this.title = data.TITLE;
                    this.content = data.CONTENT.replace(/(?:\r\n|\r|\n)/g, '<br />');
                    this.name = data.NAME;
                    this.viewCnt = data.VIEW_CNT;
                    this.regDate = data.REGDATE;
                    this.fileList = data.FILE_LIST;
                    this.vimeoLink = data.VIMEO_LINK;
                    this.youtubeLink = data.YOUTUBE_LINK;
                }
            })
            .catch(() => {
            })
            .then(() => {
            });
        },
        getVideoUrl(saveFileName) {
            return resolveApiUrl(`/api/video/${encodeURIComponent(saveFileName)}`);
        },
        getEmbedLink(link) {
            // vimeo 링크일 경우
            // const link = 'https://vimeo.com/899380705';
            const regex1 = /vimeo\.com\/(\d+)/;
            const match1 = link.match(regex1);

            if (match1) {
                const videoId = match1[1];
                const embed = `https://player.vimeo.com/video/${videoId}`;
                return embed;
            } else {
                console.error('vimeo 링크 형식이 올바르지 않습니다.');
            }

            // 유튜브 링크일 경우
            // const link = 'https://youtu.be/Xj4YPgNJx20?si=YIoYW4KfLxXRqh16';
            const regex2 = /https:\/\/youtu\.be\/([^?]+)\?si=([^&]+)/;
            const match2 = link.match(regex2);

            if (match2) {
                const videoId = match2[1]; // videoId 추출
                const si = match2[2]; // si 값 추출
                const embed = 'https://www.youtube.com/embed/' + videoId + '?si=' + si;
                return embed;
            } else {
                console.error('YouTube 링크 형식이 올바르지 않습니다.');
            }

            // 유튜브 라이브 링크일 경우
            const regex3 = /^https:\/\/www\.youtube\.com\/live\/([^\?]+)\?si=([^&]+)/;
            const match3 = link.match(regex3);

            if (match3) {
                const videoId = match3[1];
                const si = match3[2];
                const embed = 'https://www.youtube.com/embed/' + videoId + '?si=' + si;
                return embed;
            } else {
                console.error('YouTube 링크 형식이 올바르지 않습니다.');
            }
        },
      },
      mounted() {
          if(this.idx != 0){
              this.getDetail()
          }
      }
  };
  </script>
<style>
    .info-title {padding: 0rem 1rem;}
    .divider {width: 1px; height: 14px; border-left: 1px solid #7D7D7D;}
    
    .info-detail-txt {padding: 1rem 1rem;}
    .info-detail-txt p {
        font-size: 1.5rem;
    }
    .info-box,.textBox {

        border-bottom: 1px solid #4F4F4F75;
    }
    .textBox {
        padding: 1rem 1rem;
    }
    .textBox span, .textBox {
        font-size: 2rem;
    }
    .btnWrap {
        padding: 1rem 1rem;
        display: flex; align-content: flex-start; width: 100%;
    }
    .btnWrap a {
        padding: 1rem 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 2rem;
        background: #B0B0B0;
        color: #ffffff;
        cursor: pointer;
    }
</style>